import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";
import FlexColumn from "../../../components/Layout/FlexColumn/FlexColumn";
import FlexRow from "../../../components/Layout/FlexRow/FlexRow";

export const StepHeader = styled(FlexRow)<{ isActive: boolean }>`
  gap: 10px;
  align-items: flex-start;
  cursor: ${({ isActive }) => (isActive ? "pointer" : "default")};
  transition: opacity 0.2s ease;
  width: 100%;
`;

export const StepIcon = styled.div<{ isActive: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ isActive }) =>
    isActive ? colorPalette.info[500] : colorPalette.popBlack[100]};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s ease;
`;

export const ChevronIcon = styled.i<{ isOpen: boolean }>`
  color: ${colorPalette.popBlack[500]};
  font-size: 12px;
  transition: transform 0.2s ease;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  margin-left: auto;
`;

export const ProgressLine = styled.div<{ isActive: boolean; isLast: boolean }>`
  position: absolute;
  top: 16px;
  width: ${({ isActive }) => (isActive ? "1px" : "0px")};
  height: ${({ isLast }) => (isLast ? "0" : "calc(100% - 16px)")};
  background-color: ${({ isActive }) =>
    isActive ? colorPalette.info[500] : "transparent"};
  border: ${({ isActive }) =>
    isActive ? "none" : `1px dashed ${colorPalette.popBlack[100]}`};
`;
